<app-header [navClass]="'navbar-white-bg'" [buttonList]="buttonShow" [sliderTopbar]="TopbarShow" 
[isdeveloper]="developerPage" [shopPages]="shopPages" [appicons]="appicons" [Nfticons]="Nfticons" [Menuoption]="'blog'" [Settingicon]="Settingicon"></app-header>

<router-outlet (activate)="onActivate($event)"></router-outlet>

<app-footer [footerVariant]="''" [hideFooter]="hideFooter"></app-footer> 
